import CAApi from './_caApi';

class CAReceiptSaleAPI extends CAApi {
  constructor() {
    super();
  }
  controllerName = 'CAReceiptSales';
}

export default new CAReceiptSaleAPI();
